import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';
import { LprExportParams } from '@lib/vehicle-intelligence/api/models/lpr-export.params';
import { LprExportStatus } from '@lib/vehicle-intelligence/models/alpr-export-status.enum';

import { ILprExportInterface } from '../interfaces/lpr-exports.interface';

export class LprExport extends SnModel implements ILprExportInterface {
  @Expose()
  id: string;

  @Expose()
  createdTimestamp: Date;

  @Expose()
  updatedTimestamp: Date;

  @Expose()
  reportFormat: string;

  @Expose()
  status: LprExportStatus;

  @Expose()
  @Type(() => LprExportParams)
  public params: LprExportParams;

  @Expose()
  report: string;

  @Expose()
  completedAt: Date;

  @Expose()
  startedAt: Date;

  @Expose()
  fileSize: number;

  @Expose()
  failedProviders: string[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
